"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var deltacvt = __importStar(require("@xeger/quill-deltacvt"));
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'to-s... Remove this comment to see the full error message
var to_style_1 = __importDefault(require("to-style"));
/**
 * Inline CSS styles for Appfolio's proprietary Quill formats.
 */
var embedStyles = {
    calltoaction: to_style_1["default"].string({
        backgroundColor: '#0275d8',
        border: '1px solid #0275d8',
        borderRadius: '0.25rem',
        color: '#fff',
        display: 'inline-block',
        lineHeight: '1.5rem',
        margin: '1rem 0rem',
        padding: '0.2rem 0.75rem',
        verticalAlign: 'middle',
        textAlign: 'center',
        textDecoration: 'none',
        whiteSpace: 'normal'
    })
};
/**
 * HTML formatters for Appfolio's proprietary Quill formats.
 */
var embedFormats = {
    /// An HTML link disguised as a pretty blue button.
    calltoaction: function (data) {
        var id = data.id, label = data.label, field = data.field;
        var placeholder = field || "portal_quick_link:".concat(id);
        var href = "{{".concat(placeholder, "}}");
        return "<a style=\"".concat(embedStyles.calltoaction, "\" href=\"").concat(href, "\">").concat(label, "</a>");
    },
    /// A merge field.
    placeholder: function (data) { return "{{".concat(data.id, "}}"); },
    // An image
    image: function (src, attributes) {
        var float = attributes.float, width = attributes.width, height = attributes.height;
        var props = ["src=\"".concat(src, "\"")];
        width && props.push("width=\"".concat(width, "\""));
        height && props.push("height=\"".concat(height, "\""));
        var floatStyle = float ? "float: ".concat(float, ";") : '';
        var widthStyle = width ? "width: ".concat(width, "px;") : '';
        var heightStyle = height ? "height: ".concat(height, "px;") : '';
        (float || width || height) &&
            props.push("style=\"".concat(floatStyle).concat(widthStyle).concat(heightStyle, "\""));
        return "<img ".concat(props.join(' '), "/>");
    },
    // A horizontal rule.
    // Use width=0 to make it look like an empty line.
    // TODO: allow height=0 for completely invisible rule
    // TODO: allow type=break-page (with corresponding CSS style)
    rule: function (attributes) {
        var width = attributes.width;
        var props = [];
        if (width) {
            props.push("width=\"".concat(width, "\""));
            props.push("style=\"width: ".concat(width, "\""));
        }
        return "<hr ".concat(props.join(' '), "/>");
    }
};
/**
 * HTML generator that knows about proprietary Appfolio HTML extensions.
 */
var AppfolioHTML = /** @class */ (function (_super) {
    __extends(AppfolioHTML, _super);
    function AppfolioHTML(options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, options) || this;
        Object.keys(embedFormats).forEach(
        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        function (k) { return (_this.embedFormatters[k] = embedFormats[k]); });
        return _this;
    }
    return AppfolioHTML;
}(deltacvt.generators.MinimalHTML));
exports["default"] = AppfolioHTML;
